import { useQuery } from "@tanstack/react-query";
import PreOrderUEVClient from "../../clients/PreOrderUEVClient";

export const dealerAgreementStatusKey = (dealerCommonId) => [
  "dealerAgreementStatus",
  dealerCommonId,
];

export default function useDealerAgreementStatus(
  dealerCommonId,
  { enabled = true } = {}
) {
  return useQuery({
    queryKey: dealerAgreementStatusKey(dealerCommonId),
    queryFn: () => PreOrderUEVClient.getAgreementStatus(dealerCommonId),
    enabled: !!dealerCommonId && enabled,
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
